import {useEffect} from 'react';

import {useSetting} from '@/stores/settings';

import type {useSettingsStore} from '@/stores/settings';

function resolveTheme(theme: string): 'dark' | 'light' {
  return theme === 'dark' ||
    (theme === 'system' &&
      window.matchMedia('(prefers-color-scheme: dark)').matches)
    ? 'dark'
    : 'light';
}

export const useAppTheme = (): ReturnType<
  (typeof useSettingsStore)['getState']
>['theme'] => {
  const theme = useSetting('theme');

  useEffect(() => {
    const themeClass = resolveTheme(theme) === 'dark' ? 'dark' : '';

    if (themeClass) document.body.classList.add(themeClass);
    else document.body.classList.remove('dark');
  }, [theme]);

  return theme;
};

export const useResolvedTheme = () => {
  const theme = useSetting('theme');
  const resolvedTheme = resolveTheme(theme);

  return {
    theme: resolvedTheme,
    isDark: resolvedTheme === 'dark',
    isLight: resolvedTheme === 'light',
  };
};
